import styled from 'styled-components';
export var OlmLeftSideContainerStyled = styled.div.withConfig({
  displayName: "style__OlmLeftSideContainerStyled",
  componentId: "sc-66m9o0-0"
})(["padding:34px 15px 15px 0;@media ", "{display:flex;flex-direction:column;justify-content:center;align-items:center;min-width:213px;padding:0;}"], function (_ref) {
  var theme = _ref.theme;
  return theme.responsiveQuery.desktop;
});